import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { TenantCountryCodeEnum } from 'probonio-shared-ui/api';
import { useTenant } from 'probonio-shared-ui/module/me';
import { useTranslation } from 'react-i18next';
import { BrandLogo, NavbarLayout } from '.';
import { useMainDrawer } from '../../component/drawer/MainDrawerContext';
import { useAppSelector } from '../../redux/hooks';
import { BreadcrumbLink } from './NavbarLayout';
import { UserMenu } from './UserMenu';

// code to emoji https://www.npmjs.com/package/react-country-flag?activeTab=code

// offset between uppercase ascii and regional indicator symbols
const OFFSET = 127397;
const countryCodeToEmoji = (countryCode: TenantCountryCodeEnum) =>
  countryCode

    .toUpperCase()

    .replace(/./g, (char: string) => String.fromCodePoint(char.charCodeAt(0) + OFFSET));
interface Props {
  topPanel?: React.ReactNode;
  title?: string;
  breadcrumbs?: readonly BreadcrumbLink[];
}

export const AuthorizedLayout: React.FC<React.PropsWithChildren<Props>> = ({ topPanel, title, breadcrumbs, children }) => {
  const { t } = useTranslation('navigationModule');
  const { open, handleOpen: handleOpenDrawer } = useMainDrawer();
  const theme = useTheme();
  const { tenant } = useTenant();
  const user = useAppSelector(state => state.me.user);
  const isMobile = useMediaQuery(theme.breakpoints.down('xl'));
  const showFlag = tenant && !user?.employments?.some(employments => employments.tenantId === tenant.id);
  const countryFlag = showFlag ? countryCodeToEmoji(tenant.countryCode) : '';

  return (
    <NavbarLayout
      logo={
        isMobile ? (
          <BrandLogo />
        ) : (
          <Stack>
            <Typography sx={{ verticalAlign: 'middle' }} component="span" variant="h2">
              {t('titleFull')}
            </Typography>
            {tenant?.name && (
              <Typography sx={{ verticalAlign: 'middle' }} variant="h3" component="span" color="textSecondary">
                {tenant.name} {countryFlag}
              </Typography>
            )}
          </Stack>
        )
      }
      menu={<UserMenu />}
      title={title}
      breadcrumbs={breadcrumbs}
      topPanel={topPanel}
      onOpenDrawer={handleOpenDrawer}
      open={open}
    >
      {children}
    </NavbarLayout>
  );
};
